// extracted by mini-css-extract-plugin
module.exports = {"icons":"contractualaccountselect_icons__2kJxp","textContent":"contractualaccountselect_textContent__11OVo"};